<template>
  <div class="sc__dataListIterator">
    <h1
      v-if="contentTitle"
      class="sc__dataListIterator--title"
    >
      {{ contentTitle }}
    </h1>

    <div
      v-if="contentSubtitle"
      class="sc__dataListIterator--subtitle"
    >
      {{ contentSubtitle }}
    </div>

    <dl class="sc__dataListIterator--content">
      <slot
        name="items"
        :items="items"
      >
        <div
          v-for="(item, index) in items"
          v-show="shouldItemDisplay(item)"
          :key="index"
          class="sc__dataListIterator--content__itemGroup"
        >
          <slot
            name="item"
            :item="item"
          >
            <dt
              v-if="item.label"
              class="sc__dataListIterator--content__itemGroup-item--label"
            >
              {{ item.label }}
            </dt>
            <slot
              name="itemValue"
              :item="item"
            >
              <dd
                v-if="item.value"
                :class="[{'sc__dataListIterator--content__itemGroup-item--error': negativeValue(item)},
                         'sc__dataListIterator--content__itemGroup-item--value']"
              >
                {{ item.value }}
              </dd>
            </slot>
          </slot>
        </div>
      </slot>
    </dl>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
@import './style.scss';
</style>
